/**
 *  @class
 *  @function BackToTop
 */
if (!customElements.get('back-to-top')) {
  class BackToTop extends HTMLElement {
    constructor() {
      super();
      this.pageHeight = window.innerHeight;
    }

    connectedCallback() {
      this.addEventListener('click', this.onClick);
      this.addEventListener('touchstart', this.onClick, {
        passive: true
      });
      this._ticking = false;
      this._active = null;
      window.addEventListener('scroll', this.checkVisible.bind(this), {
        passive: true
      });
    }

    checkVisible() {
      // rAF-gedrosselt: pro Frame höchstens ein Check, und die Klasse nur
      // umschalten, wenn sich der Zustand ändert.
      if (this._ticking) return;
      this._ticking = true;
      window.requestAnimationFrame(() => {
        this._ticking = false;
        const active = window.scrollY > this.pageHeight;
        if (active !== this._active) {
          this._active = active;
          this.classList.toggle('back-to-top--active', active);
        }
      });
    }

    onClick() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth"
      });
    }
  }
  customElements.define('back-to-top', BackToTop);
}